import type { ReactElement } from 'react';

import { Flex, Heading, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '../../hooks/reduxHooks';

import styles from './Notifications.module.css';

export function NotificationsEmptyState(): ReactElement {
  const { t } = useTranslation();
  const { isDarkMode } = useAppSelector((state) => state.settings);
  const emptyImage = isDarkMode
    ? '/imgs/illustrations/empty-dark.svg'
    : '/imgs/illustrations/empty-light.svg';

  return (
    <Flex direction="column" align="center" justify="center" gap="3" py="5" width="100%">
      <img src={emptyImage} alt={t('There are no notifications')} className={styles.emptyImage} />
      <Flex direction="column" align="center" gap="3" width="100%">
        <Heading as="h3" size="4" weight="bold" className={styles.emptyHeading}>
          {t('There are no notifications')}
        </Heading>
        <Text size="2" weight="medium" color="gray" align="center">
          {t("New notifications will appear here when there's something to review.")}
        </Text>
      </Flex>
    </Flex>
  );
}
